/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCardChallenge200Response
 */
export interface GetCardChallenge200Response {
    /**
     * 
     * @type {any}
     * @memberof GetCardChallenge200Response
     */
    challenge: any | null;
}

/**
 * Check if a given object implements the GetCardChallenge200Response interface.
 */
export function instanceOfGetCardChallenge200Response(value: object): value is GetCardChallenge200Response {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function GetCardChallenge200ResponseFromJSON(json: any): GetCardChallenge200Response {
    return GetCardChallenge200ResponseFromJSONTyped(json, false);
}

export function GetCardChallenge200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardChallenge200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
    };
}

export function GetCardChallenge200ResponseToJSON(json: any): GetCardChallenge200Response {
    return GetCardChallenge200ResponseToJSONTyped(json, false);
}

export function GetCardChallenge200ResponseToJSONTyped(value?: GetCardChallenge200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': value['challenge'],
    };
}

